import React from "react";
import { profile, navLinks } from "../mock/mock";
import { ArrowUpRight } from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();
  const handleNav = (href) => {
    if (href.startsWith("#")) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = href;
    }
  };

  return (
    <footer className="relative bg-[#FAFAF7] border-t border-[#E5E5E0]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <h2 className="font-display text-5xl md:text-7xl lg:text-[96px] font-medium leading-[0.95]">
              Let&apos;s build<br />
              <span className="italic font-light">your visibility.</span>
            </h2>
            <a
              href={`mailto:${profile.email}`}
              className="inline-flex items-center gap-2 mt-8 font-mono text-xs sm:text-sm uppercase tracking-[0.2em] text-[#0A0A0A] link-underline whitespace-nowrap"
            >
              {profile.email} <ArrowUpRight className="h-4 w-4 shrink-0" />
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#6b6b66] mb-4">
              Navigate
            </p>
            <ul className="space-y-2">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => handleNav(l.href)}
                    className="link-underline text-sm text-[#0A0A0A]"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#6b6b66] mb-4">
              Elsewhere
            </p>
            <ul className="space-y-2">
              {profile.socials.map((s) => (
                <li key={s.name}>
                  <a
                    href={s.url}
                    target="_blank"
                    rel="noreferrer"
                    className="link-underline text-sm text-[#0A0A0A]"
                  >
                    {s.name} — {s.handle}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#E5E5E0] flex flex-col md:flex-row md:items-center justify-between gap-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#6b6b66]">
            © {year} Predrag Petrović · All rights reserved
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#6b6b66]">
            Crafted with intent · Belgrade → worldwide
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
